export const FEATURES = [
  {
    title: 'Tech-enabled',
    description:
      'We use the most modern technologies in web development. Our sites are not only well-designed, but also fast.',
    icon: 'desktop',
  },
  {
    title: 'Collect reviews',
    description:
      'Manage customer reviews and select those that you wish to display on your site.',
    icon: 'star-half-alt',
  },
  {
    title: 'Marketing campaigns',
    description: 'Launch email campaigns to connect with new and existing customers.',
    icon: ['far', 'paper-plane'],
  },
  {
    title: 'Reservations',
    description: 'Allow new and existing clients to reserve individual sessions.',
    icon: ['far', 'comments'],
  },
  {
    title: 'Constant updates',
    description:
      'We are always developing new features. If you have any suggestions, feel free to drop us a line.',
    icon: 'marker',
  },
  {
    title: 'First class support',
    description: 'Our customer success team is always available to help.',
    icon: 'life-ring',
  },
];

export const TESTIMONIALS = [
  {
    customer: 'Heather Benett',
    location: 'East Hampton, NY',
    content:
      'I love funeralApp! Had to rush earlier this year when we went fully online and they were the most helpful. Everything is super easy!',
  },
  {
    customer: 'Alex Texeira',
    location: 'San Rafael, CA',
    content:
      'I use funeralApp and love it! They built our site. I have no website experience and am able to update everything.',
  },
  {
    customer: 'Andrew Norris',
    location: 'Detroit, MI',
    content:
      'Without a doubt, I recommend funeralApp. Friendly staff, they make sure your site gets up and running. If you have questions, they are always willing to respond. I made the switch earlier this year and am super happy with the site.',
  },
];
